"use strict";

module.exports = function isObject(x) {
	return typeof x === "object" && x !== null;
};



//////////////////
// WEBPACK FOOTER
// C:/Users/tomas/OneDrive/Tomas/Materials/Talks/2018/live-compilers/code/completed/node_modules/is-object/index.js
// module id = 27
// module chunks = 0